import { Inter as GoogleInter } from 'next/font/google'
import localFont from 'next/font/local'

const Inter = GoogleInter({
  display: 'swap',
  subsets: ['latin'],
  variable: '--font-default',
  weight: ['300', '400', '500', '600', '700', '800'],
})

const Champ = localFont({
  display: 'swap',
  src: [
    {
      path: './assets/fonts/Champ/Champ.woff',
      weight: '700',
      style: 'bold',
    },
  ],
  variable: '--font-title',
})

export const fonts = `${Inter.variable} ${Champ.variable}`
